export const SIDEBAR_ORDER_CHANGED_EVENT = 'evitals-sidebar-order-changed';

export function notifySidebarOrderChanged(order) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(SIDEBAR_ORDER_CHANGED_EVENT, { detail: { order: Array.isArray(order) ? order : [] } })
  );
}

export function getSidebarRailCatalog(roleId) {
  const dashboard = { id: 'dashboard', label: 'Dashboard', icon: 'fa-th-large' };
  const enrollment = { id: 'practice-enrollment', label: 'Practice Enrollment', icon: 'fa-building' };
  const admins = { id: 'system-admins', label: 'System Admins', icon: 'fa-user-circle' };
  const caregivers = { id: 'system-caregivers', label: 'System Caregivers', icon: 'fa-users' };
  const inventory = { id: 'inventory', label: 'Inventory', icon: 'fa-cube' };
  const billing = { id: 'billing', label: 'Billing', icon: 'fa-credit-card' };
  const patientMgmt = { id: 'patient-mgmt', label: 'Patient Management', icon: 'fa-user-md' };
  const careMgmt = { id: 'care-mgmt', label: 'Care Management', icon: 'fa-heartbeat' };
  const calendar = { id: 'calendar-setting', label: 'Calendar Setting', icon: 'fa-calendar' };
  const messages = { id: 'messages', label: 'Messages', icon: 'fa-envelope' };
  const programs = { id: 'care-programs', label: 'Care Programs', icon: 'fa-cube' };
  const settings = { id: 'settings', label: 'Settings', icon: 'fa-cog' };

  switch (Number(roleId)) {
    case 1:
      return [dashboard, enrollment, admins, caregivers, inventory, billing, patientMgmt, careMgmt, calendar, messages, programs, settings];
    case 2:
      return [dashboard, caregivers, billing, patientMgmt, careMgmt, calendar, messages, settings];
    case 3:
      return [
        { id: 'analytics', label: 'Dashboard', icon: 'fa-th-large' },
        { id: 'dashboard', label: 'Overview', icon: 'fa-building' },
        patientMgmt,
        careMgmt,
        calendar,
        messages,
        billing,
        settings
      ];
    case 4:
      return [dashboard, patientMgmt, careMgmt, calendar, messages, settings];
    case 5:
      return [dashboard, patientMgmt, careMgmt, messages, settings];
    case 6:
      return [dashboard, messages, settings];
    case 7:
      return [
        { id: 'dashboard', label: 'Practices', icon: 'fa-building' },
        patientMgmt,
        careMgmt,
        messages,
        settings
      ];
    default:
      return [dashboard, settings];
  }
}

export function getSidebarItemId(item, roleId) {
  if (!item) return '';
  if (item.id) return String(item.id);
  if (item.key) return String(item.key);

  const path = String(item.path || '');
  if (path === '/settings' || path === '/patient-settings') return 'settings';
  if (path === '/chat') return 'messages';
  if (path === '/care-programs') return 'care-programs';
  if (path === '/inventory') return 'inventory';
  if (path === '/billing' || path === '/billing/sent-reports') return 'billing';
  if (path === '/admin') return 'system-admins';
  if (path === '/practices/add') return 'practice-enrollment';
  if (path === '/dashboard' || path === '/patient-dashboard' || /^\/practices\/\d+$/.test(path)) {
    return 'dashboard';
  }
  if (path === '/system-caregiver-dashboard') {
    return Number(roleId) === 7 ? 'dashboard' : 'system-caregivers';
  }
  return path.replace(/^\//, '').replace(/[^\w-]+/g, '-') || 'item';
}

export function isSidebarSettingsItem(item, roleId) {
  return getSidebarItemId(item, roleId) === 'settings';
}

export function applySidebarOrder(items, savedOrder, roleId) {
  const list = Array.isArray(items) ? items : [];
  const settingsItems = list.filter((item) => isSidebarSettingsItem(item, roleId));
  const rest = list.filter((item) => !isSidebarSettingsItem(item, roleId));
  const order = Array.isArray(savedOrder) ? savedOrder : [];

  if (order.length === 0) {
    return [...rest, ...settingsItems];
  }

  const byId = new Map(rest.map((item) => [getSidebarItemId(item, roleId), item]));
  const used = new Set();
  const ordered = [];

  order.forEach((id) => {
    const item = byId.get(String(id));
    if (item && !used.has(String(id))) {
      ordered.push(item);
      used.add(String(id));
    }
  });

  rest.forEach((item) => {
    const id = getSidebarItemId(item, roleId);
    if (!used.has(id)) ordered.push(item);
  });

  return [...ordered, ...settingsItems];
}

export function moveSidebarItem(order, fromIndex, toIndex) {
  if (!Array.isArray(order)) return [];
  if (fromIndex === toIndex) return [...order];
  if (fromIndex < 0 || toIndex < 0 || fromIndex >= order.length || toIndex >= order.length) {
    return [...order];
  }
  const next = [...order];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
}
